import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SelectItem } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { NotificationTypes } from 'src/app/app.enums';
import { ImageCroppedResponse } from 'src/app/common/image-cropper/image-cropper.component';
import { ArtFlowSelectItem } from 'src/app/models/artflow.selectitem';
import { SaveGalleryStaffRequest } from 'src/app/models/staff.model';
import { ApplicationUser, AuthConfig, AuthService, ResponseObject } from 'src/app/Services/auth.service';
import { CloudinaryImageService } from 'src/app/Services/cloudinary-image.service';
import { GalleriesService, GalleryAddress, GalleryItems } from 'src/app/Services/galleries.service';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { UsersService } from 'src/app/Services/users.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-onboarding-gallery-personal-details',
    templateUrl: './onboarding-gallery-personal-details.component.html',
    standalone: false
})
export class OnboardingGalleryPersonalDetailsComponent implements OnInit {
  @ViewChild('additionalFileUploadCmp') additionalFileUploadCmp!: FileUpload;
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  public enableCropper: boolean = true;
  public currentSelectedImageToCrop?: File;
  public showCropperDialog: boolean = false;
  public additionalFiles: any[] = [];
  public selectedFile!: File;
  @Output() onSave = new EventEmitter<ApplicationUser>();
  public formData: ApplicationUser = new ApplicationUser();
  @ViewChildren('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  public userId!: string;
  public uploader!: FormGroup;
  public authConfig: AuthConfig = {};
  public isGallery: boolean | undefined = false;
  public isBankingInformtionDailogVisible: boolean = false;
  public loginUserId!: string;
  public Staff: SaveGalleryStaffRequest[] = [];
  public staffLoading: boolean = false;
  public staffDailogVisible: boolean = false;
  public staffFormsData: SaveGalleryStaffRequest = {} as SaveGalleryStaffRequest;
  public galleryItems = new GalleryItems();
  public selectedGalleryAddress!: GalleryAddress;
  public items: string[] = ['Artist', 'Manafacture', 'Public Gallery', 'Exhibition space', 'Charity', 'Government Organization', 'Other'];
  public commissionOptions: { value: number; label: string }[] = [];
  public terms: string[] = ['3 Days', '7 Days', '30 Days'];
  constructor(
    private router: Router,
    private authService: AuthService,
    private uploadService: CloudinaryImageService,
    private ngxSpinnerService: NgxSpinnerService,
    private notificationsService: NotificationsService,
    private usersService: UsersService,
    private fb: FormBuilder,
    private galleriesService: GalleriesService,
    private transloco: TranslocoService
  ) {
    this.formData = new ApplicationUser();
    this.staffFormsData = new SaveGalleryStaffRequest();
    this.uploader = this.fb.group({
      file: [null],
    });
    this.selectedGalleryAddress = new GalleryAddress();
    this.galleryItems.GallerySaleType = 'Consignment';
    if (this.formData.Gallery) {
      this.formData.Gallery.GalleryType = 'Consignment';
    }
    // Generate options from 5% to 90% with a step of 5%
    for (let i = 5; i <= 90; i += 5) {
      this.commissionOptions.push({ value: i, label: `${i}%` });
    }
  }

  ngOnInit(): void {
    this.userId = this.authService.getUserId();
    this.authConfig = this.authService.getAuthConfig();
    this.isGallery = this.authConfig.IsGallery;
    this.getUserById();
    if (this.authConfig.IsGallery) {
      this.getGalleryById(this.userId);
      // this.getAllGalleryStaff();
    }
  }

  public getGalleryById(galleryId: string) {
    this.ngxSpinnerService.show();
    this.galleriesService.fetchById(galleryId).subscribe((gallery) => {
      // this.formData.GalleryAddresses = gallery.GalleryAddresses;
      this.galleryItems = gallery;
      this.ngxSpinnerService.hide();
    }, (error) => { console.error(error); this.ngxSpinnerService.hide(); });
  }


  private getUserById() {
    this.ngxSpinnerService.show();
    this.usersService.getUserDetails().subscribe(
      (res) => {
        this.formData = res;
        console.log(this.formData);
        this.ngxSpinnerService.hide();
      },
      (error) => {
        console.error('Error fetching the logged-in user: ', error);
        this.ngxSpinnerService.hide();
      }
    );
  }

  // Method for handling file selection
  public onFileSelected(File: File[]) {
    this.selectedFile = File[0]; // Get the selected file
    console.log(this.selectedFile);

    // Check if the selected file is an image
    const isImage = this.selectedFile && this.selectedFile.type.includes('image');
    if (isImage) {
      this.showCropperDialog = true; // Show the cropper dialog
      this.currentSelectedImageToCrop = this.selectedFile; // Set the image to crop
    } else {
      console.log('Selected file is not an image');
    }
  }

  // Method to handle the cropped image
  public onImageCropped(croppedImage: ImageCroppedResponse) {
    console.log(croppedImage);
    // Set the cropped image as the selected file
    this.selectedFile = croppedImage.CroppedImage;
    // Now upload the cropped image
    this.uploadImage();
    // Close the cropper dialog
    this.showCropperDialog = false;
  }

  // Method to handle closing the cropper dialog
  public onImageCropperClose($event: any) {
    // this.showCropperDialog = false;
    if ($event.skipCropping) {
      this.selectedFile = null!;
      this.showCropperDialog = false;
      if(this.fileUpload){
        this.fileUpload.clear();
      }
    }
  }

  // Method to upload the image
  public uploadImage() {
    if (this.selectedFile) {
      const formData = new FormData();
      formData.append('ImageFile', this.selectedFile);
      this.uploadService.uploadImage(formData).subscribe(
        (res: any) => {
          this.formData.ImgUrl = res;
        },
        (error) => {
          console.error('Error uploading image:', error);
        }
      );
    } else {
      console.log('No image to upload.');
    }
  }

  // Method to remove the uploaded image
  public removeImg() {
    this.formData.ImgUrl = null!;
  }

  public editGalleryAddress(event: any) {
    this.galleryItems.GalleryAddresses = event;
    // this.formData.GalleryAddresses = event;
  }


  public updateProfile() {
    this.isBankingInformtionDailogVisible = false;
    this.ngxSpinnerService.show();
    this.usersService.updateUser(this.formData.Id, this.formData).subscribe(
      (response: ResponseObject) => {
        this.ngxSpinnerService.hide();
        if (response.Success) {
          this.getGalleryById(this.userId);
          this.onSave.emit(this.formData); // Emit the updated user data
          this.notificationsService.showNotification(this.transloco.translate('onboardingGalleryPersonalDetails.successTitle'), this.transloco.translate('onboardingGalleryPersonalDetails.changesSavedSuccessfully'), NotificationTypes.Success);
        } else {
          this.notificationsService.showNotification(this.transloco.translate('onboardingGalleryPersonalDetails.errorTitle'), response.ResponseMessage, NotificationTypes.Error);
        }
      },
      (error) => {
        console.error(error);
        this.ngxSpinnerService.hide();
      }
    );
  }

}
